import React, { useContext, useEffect, useMemo } from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';
import { Tag } from 'ck-ui';
import classnames from 'classnames';
import _findIndex from 'lodash/findIndex';
import { ProductListingPageContext } from '../context';
import { Label } from '../utils';
import MERGE_LABELS from '../data/sizeLabels';
import styles from './MyFilter.module.scss';

/**
 * @todo to see if we can reuse sizeFacet normaliseLabel
 * Their data format is really different that's the reason we choose to build a new one
 */
const normaliseSize = (item) => {
  const values = [];
  item.currentRefinement.forEach((element) => {
    const mergeIndex = _findIndex(MERGE_LABELS, (o) => o.alts.indexOf(element) >= 0);
    if (mergeIndex >= 0) {
      let targetIndex = -1;
      values.forEach((v, index) => {
        if (v.label === MERGE_LABELS[mergeIndex].target) {
          targetIndex = index;
        }
      });
      if (targetIndex !== -1) {
        values[targetIndex].value = `${values[targetIndex].value}, ${element}`;
      } else {
        values.push({
          label: MERGE_LABELS[mergeIndex].target,
          value: element,
        });
      }
    } else {
      values.push({
        label: element,
        value: element,
      });
    }
  });
  return values;
};

/**
 * Translate category
 */
const categoryTranslator = (item) => {
  let values = item.currentRefinement.split(' > ');
  if (values.length === 3) {
    values = values[2];
  } else if (values.length === 2) {
    values = Label.getLocaleString(values[1], 'subcategory');
  } else {
    values = Label.getLocaleString(values[0], 'category');
  }
  return values;
};

const MyFilter = connectCurrentRefinements(({ items, refine }) => {
  const { isMobile } = useContext(ProductListingPageContext);
  const filters = useMemo(() => items?.flatMap(({ attribute, currentRefinement }) => {
    if (Array.isArray(currentRefinement)) {
      return currentRefinement.map(refinement => `${attribute}:${refinement}`);
    }
    return `${attribute}:${currentRefinement}`;
  }), [items]);
  const indexName = items?.[0]?.index;

  useEffect(() => {
    localStorage.setItem('ck_algolia_filters', JSON.stringify(filters?.slice(0, 10)));
    if (filters?.length > 0) {
      window.aa?.('viewedFilters', {
        index: indexName,
        eventName: 'viewed_filters',
        filters: filters.slice(0, 10),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters?.length, indexName]);

  const clearAll = () => {
    refine(items);
  };

  const onClose = (item, value = '') => {
    const v = value.split(', ');
    if (item.items) {
      const filterItems = item.items.filter((element) => v.indexOf(element.label) !== -1);
      refine(filterItems);
    } else {
      refine(item.value);
    }
  };

  const tags = [];
  // TODO to see if we improve this to avoid some unnessary reconciliation via extracting
  items.forEach((item) => {
    let tagContent = '';
    if (item.attribute === 'price') {
      // deal with undefined price issue when refreshing
      const { min, max } = item.currentRefinement;
      if (min && max) {
        tagContent = `$${min} - $${max}`;
      }
      if (!min) tagContent = `Price <= $${max}`;
      if (!max && max !== 0) tagContent = `Price >= $${min}`;
      tags.push(
        <Tag
          closable
          key={item.attribute}
          onClose={() => onClose(item)}
        >
          {tagContent}
        </Tag>
      );
    } else if (item.attribute === 'menu.categories') {
      const values = categoryTranslator(item);
      tags.push(
        <Tag
          className="is-capitalized"
          closable
          key={item.attribute}
          onClose={() => onClose(item)}
        >
          {values}
        </Tag>
      );
    } else if (item.attribute === 'sizes') {
      const values = normaliseSize(item);
      values.forEach(value => {
        tags.push(
          <Tag
            closable
            key={item.attribute + value.label}
            onClose={() => onClose(item, value.value)}
          >
            Size: {value.label}
          </Tag>
        );
      });
    } else if (item.attribute === 'isOnSale') {
      tags.push(
        <Tag
          closable
          key={item.attribute}
          onClose={() => onClose(item)}
        >
          On Sale
        </Tag>
      );
    } else {
      item.currentRefinement.forEach(value => {
        tags.push(
          <Tag
            className="is-capitalized"
            closable
            key={item.attribute + value}
            onClose={() => onClose(item, value)}
          >
            {value}
          </Tag>
        );
      });
    }
  });

  if (tags.length > 0) {
    return (
      <>
        <div className={classnames({
          [styles.mobileContainer]: isMobile,
          [styles.container]: !isMobile,
        })}
        >
          {tags.map((tag) => tag)}
          <Tag
            closable
            key="clearAll"
            type="button"
            onClose={clearAll}
          >
            Clear All
          </Tag>
        </div>
      </>
    );
  }
  return null;
});

export { MyFilter };
